import React, { useState } from 'react';
import styles from './setting.module.css'
import {BiArrowBack} from 'react-icons/bi'
import {Link} from 'react-router-dom'
import Switch from "react-switch";

const NotificationSet =()=>{
    const [post,setPost]=useState(true);
    const [comment,setComment]=useState(false);
    const [likes,setLikes]=useState(true);
    const [challengePost,setChallengePost]=useState(true);
    const [follow,setFollow]=useState(true);



    return(
        <div >
             <div  className={styles.backbtn} >
            <Link to="/setting">
           <BiArrowBack/>
         </Link>
         <span>Notification Setting</span>
         </div>
         <div className={styles.notificationCon} >
            
            <br/>
            <div className={styles.notificationList}>
            <div className={styles.pvt}>
            <label 
              className={styles.actypelabel} htmlFor="private">Post Notification</label>   
              <Switch 
               onColor="#C19AE6"
               onHandleColor="#7124BD"
               onChange={()=>setPost(!post)} checked={post} />
              </div>
                <br/>
            <div className={styles.pvt}>
            <label 
              className={styles.actypelabel} htmlFor="private">Comment Notification</label>   
              <Switch 
               onColor="#C19AE6"
               onHandleColor="#7124BD"
               onChange={()=>setComment(!comment)} checked={comment} />
             
                </div>    
                <br/>
            <div className={styles.pvt}>
            <label 
              className={styles.actypelabel} htmlFor="private">Like Notification</label>   
              <Switch 
               onColor="#C19AE6"
               onHandleColor="#7124BD"
               onChange={()=>setLikes(!likes)} checked={likes} />
             
                </div>    

                <br/>
            <div className={styles.pvt}>
            <label 
              className={styles.actypelabel} htmlFor="private">Challenge Post Notification</label>   
              <Switch 
               onColor="#C19AE6"
               onHandleColor="#7124BD"
               onChange={()=>setChallengePost(!challengePost)} checked={challengePost} />
              </div>  
              <br/>  
              <div className={styles.pvt}>
              <label 
              className={styles.actypelabel} htmlFor="private">Challenge Post Notification</label>   
              <Switch 
               onColor="#C19AE6"
               onHandleColor="#7124BD"
               onChange={()=>setFollow(!follow)} checked={follow} />
             
                </div>
                </div>    
       

        </div>
        </div>
    )
}

export default NotificationSet